import React, { Component } from "react";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { apiURL, fetchAccountDetail, fetchStockDetail } from "./API";
import { Box, Grid } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import {
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import MaterialTable from "./CustomTool/MaterialTable";
import CtTextField from "./CustomTool/CtTxt";

class TrialBalanceReport extends Component {
  state = {
    columnsdata: [
      {
        accessorKey: "vac_ledgername",
        header: "Ledger Name",
        enableColumnDragging: false,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        size: 160,
      },
      {
        accessorKey: "vac_groupname",
        header: "Group Type",
        enableColumnDragging: false,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        size: 50,
      },
      {
        accessorKey: "dec_opbalance",
        header: "Opening",
        enableColumnDragging: false,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        muiTableBodyCellProps: { align: "right" },
        muiTableHeadCellProps: {
          align: "right",
        },
        size: 50,
      },
      {
        accessorKey: "dec_credit",
        header: "Total Credit",
        enableColumnDragging: false,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        muiTableBodyCellProps: { align: "right" },
        muiTableHeadCellProps: {
          align: "right",
        },
        size: 50,
      },
      {
        accessorKey: "dec_debit",
        header: "Total Debit",
        size: 50,
        enableColumnDragging: false,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        muiTableBodyCellProps: { align: "right" },
        muiTableHeadCellProps: {
          align: "right",
        },
      },
      {
        accessorKey: "OutStanding",
        header: "Out Standing",
        enableColumnDragging: false,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        muiTableBodyCellProps: { align: "right" },
        muiTableHeadCellProps: {
          align: "right",
        },
        size: 50,
      },
    ],
    formdata: { txtTotalCR: 0, txtTotalDR: 0 },
    rows: [],
    searchColumns: [],
    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
  };
  componentDidMount() {
    document.title = "RiTe Account : Trial Balance Report";
    this.props.setActiveMenu("TrialBalanceReport");
  }

  listTrial = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "TrialBalanceList",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      vac_company: localStorage.getItem("CompanyName"),
    };
    fetchAccountDetail(reqData)
      .then((res) => {
        let rows = res.data.TrialBalanceList,
          rowsCount = rows.length;
        let txtTotalCR = 0,
          txtTotalDR = 0;
        let Total = res.data.Total;
        txtTotalCR = Total.FinalTotal;
        txtTotalDR = Total.Debit;

        this.props.closeUpdateProcessing();
        this.setState({
          formdata: { txtTotalCR, txtTotalDR },
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
  };

  TrialBalanceReport = () => {
    this.props.notifyProcessing();
    let reqData = [
      { name: "Op", value: "TrialBalanceReport" },
      { name: "bint_acid", value: localStorage.getItem("acid") },
      { name: "bint_acyear", value: localStorage.getItem("ACY") },
      { name: "vac_company", value: localStorage.getItem("CompanyName") },
    ];

    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    let popupURL = apiURL + "accountreportdetail.php?" + queryString;

    window.open(
      popupURL,
      "TrialBalanceReport",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
    this.handleClose();
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["cmbGroupName"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  render() {
    let rowsCount = this.state.rows.length;
    // console.log(
    //   "CR-DR",
    //   this.state.formdata.txtTotalCR,
    //   this.state.formdata.txtTotalDR
    // );
    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Trial Balance Report</b>
          </label>
        </Grid> */}

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
          marginTop={2}
          spacing={2}
        >
          <Grid item>
            <CtBtn
              label="List"
              iconName={"List"}
              onClick={() => {
                this.listTrial();
              }}
              variant="outlined"
            />
          </Grid>

          <Grid item>
            <CtBtn
              label="PDF"
              onClick={() => {
                this.TrialBalanceReport();
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className="title"
          marginTop={2}
          spacing={2}
        >
          {this.state.rows.length > 0 && (
            <>
              <Grid item>
                <CtTextField
                  id="txtTotalCR"
                  label="Total Credit*"
                  value={this.state.formdata.txtTotalCR}
                  handleOnChange={this.handleOnChange}
                  width={200}
                  onKeyDown={this.props.onKeyDown}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtTextField
                  id="txtTotalDR"
                  label="Total Debit*"
                  value={this.state.formdata.txtTotalDR}
                  handleOnChange={this.handleOnChange}
                  width={200}
                  onKeyDown={this.props.onKeyDown}
                  disabled={true}
                />
              </Grid>
            </>
          )}
          <Grid item marginTop={3}>
            {/* <TableList
            columns={this.state.columns}
            counter={this.state.counter}
            rows={this.state.rows}
            rowsCount={rowsCount}
            rowsPerPage={this.state.rowsPerPage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          /> */}
            <MaterialTable
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("TrialBalance")}
              density={"compact"}
              hideColIdList={["mrt-row-actions"]}
            />
          </Grid>
        </Grid>
        {/* <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid> */}
      </form>
    );
  }
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(TrialBalanceReport))));
